import { motion } from 'framer-motion';
import { styled } from 'styled-components';

import { CommonAction, recipesCommonAction, styledMedia, styledReset, styledTypography } from '@pkg/primitives';

export const TriggerAction = styled(CommonAction)`
    ${recipesCommonAction.basic};
    justify-content: space-between;
    gap: 16px;
    padding-left: 16px;
    padding-right: 16px;
    min-width: 140px;
    height: 40px;
    border: 2px solid rgba(255, 255, 255, 0.1);

    &[aria-pressed] {
        background-color: rgba(255, 255, 255, 0.1);

        svg {
            scale: -1;
        }
    }

    &:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }

    &:active {
        background-color: rgba(255, 255, 255, 0.06);
    }
`;

export const TriggerActionLabel = styled.span`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    display: block;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: -0.02em;
`;

export const TriggerActionIcon = styled.span`
    ${styledMedia.iconWrapper};
    width: 12px;
    height: 12px;
`;

export const MenuWrapper = styled.div`
    width: 100%;
    max-width: 200px;
`;

export const MenuInside = styled(motion.div)`
    display: flex;
    flex-direction: column;
    padding: 5px;
    width: 100%;
    border-radius: 10px;
    background-color: rgb(255, 255, 255, 0.04);
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(16px);
`;

export const MenuButton = styled.button`
    ${styledReset.button}
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    line-height: 120%;
    letter-spacing: -0.42px;
    text-align: left;

    padding: 10px 16px;
    border-radius: 5px;
    justify-content: flex-start;

    transition: background-color 0.2s ease-in-out;

    &:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }
`;
